import { render, staticRenderFns } from "./VIconArrowRight.vue?vue&type=template&id=97af50b4&"
import script from "./VIconArrowRight.vue?vue&type=script&lang=js&"
export * from "./VIconArrowRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97af50b4')) {
      api.createRecord('97af50b4', component.options)
    } else {
      api.reload('97af50b4', component.options)
    }
    module.hot.accept("./VIconArrowRight.vue?vue&type=template&id=97af50b4&", function () {
      api.rerender('97af50b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VIcons/VIconArrowRight.vue"
export default component.exports